import { render, staticRenderFns } from "./blueSeaMerchant.vue?vue&type=template&id=6bf8af11&scoped=true&"
import script from "./blueSeaMerchant.vue?vue&type=script&lang=js&"
export * from "./blueSeaMerchant.vue?vue&type=script&lang=js&"
import style0 from "./blueSeaMerchant.vue?vue&type=style&index=0&id=6bf8af11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8af11",
  null
  
)

export default component.exports